(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-artist-editorial"] && !Shopify.designMode) return;
  try {
    
/** code by squarestylist.com — standoutshopify.com **/
class SqshTextReveal extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;
    this.classList.add('sqsh-js');

    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hasIO = 'IntersectionObserver' in window;
    const mobile = window.matchMedia('(max-width: 749px)').matches;

    this.targets = Array.from(this.querySelectorAll('[data-sqsh-reveal]'));
    this.slides = Array.from(this.querySelectorAll('[data-sqsh-slide]'));

    // Split reveal targets into letters. On mobile, mark them for the timed
    // wave BEFORE splitting so the letters start dim (no flash of full colour).
    this.targets.forEach((el) => {
      if (mobile && !reduce) el.classList.add('sqsh-reveal-anim');
      this.split(el);
    });

    // ----- Image slide-in (CSS scopes the effect to mobile) -----
    if (this.slides.length) {
      if (reduce || !hasIO) {
        this.slides.forEach((el) => el.classList.add('is-inview'));
      } else {
        const slideObserver = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-inview');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        this.slides.forEach((el) => slideObserver.observe(el));
      }
    }

    if (!this.targets.length) return;

    if (reduce) {
      this.targets.forEach((el) => el.style.setProperty('--sqsh-p', '1'));
      return;
    }

    // ----- Mobile: play the timed wave when the title enters the viewport -----
    if (mobile) {
      if (!hasIO) {
        this.targets.forEach((el) => el.classList.add('is-playing'));
      } else {
        const playObserver = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-playing');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.25, rootMargin: '0px 0px -5% 0px' });
        this.targets.forEach((el) => playObserver.observe(el));
      }
      return;
    }

    // ----- Desktop: scroll-linked reveal -----
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    window.addEventListener('load', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    if (this.onScroll) {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('load', this.onScroll);
    }
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const startLine = vh * 0.9;   // reveal begins when the element reaches here
    const endLine = vh * 0.35;    // fully revealed by here
    const span = startLine - endLine;

    this.targets.forEach((el) => {
      const top = el.getBoundingClientRect().top;
      let p = (startLine - top) / span;
      if (p < 0) p = 0;
      else if (p > 1) p = 1;
      el.style.setProperty('--sqsh-p', p.toFixed(4));
    });
  }

  split(el) {
    if (el.dataset.sqshSplit) return;

    const label = el.textContent.replace(/\s+/g, ' ').trim();
    const counter = { n: 0 };
    this.walk(el, counter);

    el.style.setProperty('--n', String(Math.max(counter.n, 1)));
    el.dataset.sqshSplit = 'true';
    if (label) el.setAttribute('aria-label', label);
  }

  walk(node, counter) {
    Array.from(node.childNodes).forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.textContent;
        if (!text) return;

        const frag = document.createDocumentFragment();
        for (const ch of text) {
          // Keep whitespace as real text nodes so lines still wrap normally.
          if (ch === ' ' || ch === '\n' || ch === '\t') {
            frag.appendChild(document.createTextNode(ch));
            continue;
          }
          const span = document.createElement('span');
          span.className = 'sqsh-char';
          span.setAttribute('aria-hidden', 'true');
          span.textContent = ch;
          span.style.setProperty('--i', String(counter.n++));
          frag.appendChild(span);
        }
        node.replaceChild(frag, child);
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        this.walk(child, counter);
      }
    });
  }
}

if (!customElements.get('sqsh-text-reveal')) {
  customElements.define('sqsh-text-reveal', SqshTextReveal);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-artist-v2"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  if (!customElements.get('sqsh-artist-feature')) {
    customElements.define(
      'sqsh-artist-feature',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.classList.contains('sqsh-artist-feature--motion')) return;

          const reveal = () => this.classList.add('sqsh-artist-feature--in');

          if (!('IntersectionObserver' in window)) {
            reveal();
            return;
          }

          this._io = new IntersectionObserver(
            (entries, obs) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  reveal();
                  obs.disconnect();
                }
              });
            },
            { threshold: 0.12 }
          );

          this._io.observe(this);
        }

        disconnectedCallback() {
          if (this._io) this._io.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-hero-section"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  if (!customElements.get('sqsh-page-hero')) {
    customElements.define(
      'sqsh-page-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.mode = this.dataset.topBehavior || 'behind';
          this._onResize = this._onResize.bind(this);
          this._onScroll = this._onScroll.bind(this);

          this.collapseGap();
          // Re-measure once fonts, images and late-loading sections have settled.
          window.addEventListener('load', this._onResize);
          window.addEventListener('resize', this._onResize, { passive: true });

          this.setupExit();
        }

        disconnectedCallback() {
          window.removeEventListener('load', this._onResize);
          window.removeEventListener('resize', this._onResize);
          this.stopWatching();
          const wrapper = this.closest('.shopify-section');
          if (wrapper) wrapper.style.marginTop = '';
        }

        // Pulls the hero up by whatever gap the theme leaves above it — whether that
        // comes from the section wrapper, the page container, or an empty block above.
        collapseGap() {
          const wrapper = this.closest('.shopify-section') || this;
          wrapper.style.marginTop = '0px';

          const y = window.pageYOffset;
          const heroTop = this.getBoundingClientRect().top + y;

          // "behind" pulls to the very top of the page, under a transparent header.
          // "below" stops at the bottom of whatever sits directly above.
          let target = 0;
          if (this.mode !== 'behind') {
            const prev = wrapper.previousElementSibling;
            if (prev) {
              target = prev.getBoundingClientRect().bottom + y;
            } else if (wrapper.parentElement) {
              target = wrapper.parentElement.getBoundingClientRect().top + y;
            }
          }

          const delta = heroTop - target;
          if (delta > 0.5) {
            wrapper.style.marginTop = -delta + 'px';
          }
        }

        _onResize() {
          this.collapseGap();
          if (this.watching) this.measure();
        }

        // The entry animation is pure CSS. This only decides when the letters leave.
        setupExit() {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.animate !== 'true' || reduced) return;

          this.exitPoint = parseFloat(this.dataset.exitPoint);
          if (isNaN(this.exitPoint)) this.exitPoint = 8;
          this.replay = this.dataset.replay === 'true';
          this.isOut = false;
          this.ticking = false;
          this.watching = true;

          // Captured on the document as well, so it still fires when the page
          // scrolls inside a wrapper element rather than the window itself.
          window.addEventListener('scroll', this._onScroll, { passive: true });
          document.addEventListener('scroll', this._onScroll, { passive: true, capture: true });
          this.measure();
        }

        stopWatching() {
          this.watching = false;
          window.removeEventListener('scroll', this._onScroll);
          document.removeEventListener('scroll', this._onScroll, true);
        }

        _onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(() => {
            this.ticking = false;
            this.measure();
          });
        }

        measure() {
          const rect = this.getBoundingClientRect();
          if (!rect.height) return;

          // Pixels the hero has travelled up past the top of the viewport, so the
          // exit fires on the first bit of scroll rather than deep into the image.
          const scrolled = -rect.top;
          const threshold = Math.max(this.exitPoint, 2);
          // A small band around the threshold so the letters don't flicker on it.
          const shouldExit = this.isOut ? scrolled > threshold - 2 : scrolled >= threshold;
          if (shouldExit === this.isOut) return;

          this.isOut = shouldExit;
          this.classList.toggle('sqsh-page-hero--out', shouldExit);

          // Coming back up, rerun the reveal rather than just fading the lines in.
          if (!shouldExit) this.restartEntry();

          // Without replay, the exit is one-way and the listeners can retire.
          if (shouldExit && !this.replay) this.stopWatching();
        }

        restartEntry() {
          this.classList.remove('sqsh-page-hero--motion');
          void this.offsetWidth; // forces the reflow that lets the animation start over
          this.classList.add('sqsh-page-hero--motion');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-flow"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/

  if (!customElements.get('sqsh-contact-flow')) {
    customElements.define(
      'sqsh-contact-flow',
      class SqshContactFlow extends HTMLElement {
        connectedCallback() {
          // Shopify bounces back to this page after a successful post, often to
          // the form's own anchor further down. Pull the view to the top of this
          // section so the thank-you is what lands on screen, and move focus
          // there for screen readers without a second jump.
          const success = this.querySelector('[data-sqsh-success]');
          if (success) {
            const settle = () => {
              this.scrollIntoView({ block: 'start' });
              success.focus({ preventScroll: true });
            };
            settle();
            // Run again after the browser has honoured any URL fragment.
            window.addEventListener('load', settle);
            setTimeout(settle, 60);
            return;
          }

          this.form = this.querySelector('form');
          if (!this.form) return;

          this.viewport = this.querySelector('[data-sqsh-viewport]');
          this.status = this.querySelector('[data-sqsh-status]');
          this.steps = Array.from(this.querySelectorAll('[data-sqsh-step]'));
          this.stepMap = {};
          this.steps.forEach((step) => {
            this.stepMap[step.dataset.sqshStep] = step;
          });

          this.topics = Array.from(this.querySelectorAll('[data-sqsh-topic]'));
          this.detailsHeading = this.querySelector('[data-sqsh-details-heading]');
          this.reference = this.querySelector('[data-sqsh-reference]');
          this.referenceInput = this.querySelector('[data-sqsh-reference-input]');
          this.referenceLabel = this.querySelector('[data-sqsh-reference-label]');
          this.message = this.querySelector('[data-sqsh-message]');
          this.imagesField = this.querySelector('[data-sqsh-images]');
          this.submitButton = this.querySelector('[data-sqsh-submit]');

          this.files = [];
          this.trail = [];
          this.maxImages = parseInt(this.dataset.maxImages || '0', 10);

          this.bindChoices();
          this.bindFields();
          this.bindNav();
          this.bindUploader();
          this.bindCustom();

          // Only the first step is shown once the script is running. Without
          // JavaScript every step stays in the page as one long form.
          this.current = this.steps[0].dataset.sqshStep;
          this.steps.forEach((step) => {
            step.hidden = step !== this.steps[0];
          });

          this.form.addEventListener('submit', this.handleSubmit.bind(this));
          this.wireCaptcha();
          this.applyDeepLink();

          this._onBlockSelect = this.handleBlockSelect.bind(this);
          document.addEventListener('shopify:block:select', this._onBlockSelect);
        }

        // A menu link can drop the visitor straight into one choice's flow, past
        // the first question, with ?open=<key> on the contact page URL (or a
        // #<key> at the end). It matches on the choice's Deep-link key first,
        // then falls back to its flow name ("commission") and a slug of its
        // label — so ?open=commission works even before the key field is filled
        // in. Back still returns to the first step, so nothing is trapped.
        applyDeepLink() {
          const key = this.readDeepLinkKey();
          if (!key) return;

          const slug = (value) =>
            (value || '')
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '');

          const byKey = (input) => (input.dataset.linkKey || '').toLowerCase() === key;
          const byPath = (input) => (input.dataset.path || '').toLowerCase() === key;
          const bySlug = (input) => slug(input.value).indexOf(key) === 0;

          const topic =
            this.topics.filter(byKey)[0] ||
            this.topics.filter(byPath)[0] ||
            this.topics.filter(bySlug)[0];
          if (!topic) return;

          topic.checked = true;
          topic.dispatchEvent(new Event('change', { bubbles: true }));

          const next = this.nextName();
          if (!next) return;
          this.trail.push(this.current);
          this.show(next, 'forward', true);
        }

        readDeepLinkKey() {
          let key = '';
          try {
            key = new URLSearchParams(window.location.search).get('open') || '';
          } catch (error) {
            key = '';
          }
          if (!key && window.location.hash.length > 1) {
            key = window.location.hash.slice(1);
          }
          return decodeURIComponent(key || '')
            .toLowerCase()
            .trim();
        }

        // If the store has hCaptcha on (the Shopify default), tie it to this
        // form so a valid token rides along with the submission. Shopify asks
        // theme code that submits forms itself to do this, rather than lean on
        // the /challenge redirect — which is the bare, off-brand captcha page.
        // No-ops cleanly when captcha is switched off in Preferences.
        wireCaptcha() {
          try {
            const captcha = window.Shopify && window.Shopify.captcha;
            if (captcha && typeof captcha.protect === 'function') {
              captcha.protect(this.form);
            }
          } catch (error) {
            /* captcha not available on this store */
          }
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this._onBlockSelect);
          this.files.forEach((item) => URL.revokeObjectURL(item.url));
        }

        /* ---------- wiring ---------- */

        bindChoices() {
          this.querySelectorAll('[data-sqsh-choice]').forEach((group) => {
            group.addEventListener('change', () => {
              this.clearChoiceError(group);
              this.syncReady(group.closest('[data-sqsh-step]'));
              this.syncCustom();
            });
          });
        }

        bindFields() {
          this.querySelectorAll('[data-sqsh-field]').forEach((field) => {
            field.addEventListener('input', () => {
              // Only re-check once a field has already been flagged, so nobody is
              // told they're wrong halfway through typing their first letter.
              if (field.getAttribute('aria-invalid') === 'true') this.check(field);
              if (field.hasAttribute('data-sqsh-grow')) this.grow(field);
            });
            field.addEventListener('blur', () => {
              if (field.getAttribute('aria-invalid') === 'true') this.check(field);
            });
            if (field.hasAttribute('data-sqsh-grow')) this.grow(field);
          });
        }

        bindNav() {
          this.querySelectorAll('[data-sqsh-next]').forEach((button) => {
            button.addEventListener('click', () => {
              const step = button.closest('[data-sqsh-step]');
              if (!this.validate(step)) return;
              const next = this.nextName();
              if (!next) return;
              this.trail.push(this.current);
              this.show(next, 'forward');
            });
          });

          this.querySelectorAll('[data-sqsh-back]').forEach((button) => {
            button.addEventListener('click', () => {
              const previous = this.trail.pop();
              if (previous) this.show(previous, 'back');
            });
          });
        }

        bindUploader() {
          this.fileInput = this.querySelector('[data-sqsh-file]');
          this.addButton = this.querySelector('[data-sqsh-add]');
          this.thumbs = this.querySelector('[data-sqsh-thumbs]');
          if (!this.fileInput || !this.addButton) return;

          this.addButton.addEventListener('click', () => this.fileInput.click());
          this.fileInput.addEventListener('change', () => {
            this.addFiles(Array.from(this.fileInput.files || []));
            this.fileInput.value = '';
          });
        }

        // Focusing or typing in the Custom field is what picks the Custom size —
        // there's no separate radio to tick. Selecting it fires the usual change
        // so the scribble and the ready state update like any other choice.
        bindCustom() {
          const radio = this.querySelector('[data-sqsh-custom]');
          const input = this.querySelector('[data-sqsh-custom-input]');
          if (!radio || !input) return;

          const pick = () => {
            if (radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          };
          input.addEventListener('focus', pick);
          input.addEventListener('input', pick);
        }

        /* ---------- the path through the form ---------- */

        selectedTopic() {
          return this.topics.filter((input) => input.checked)[0] || null;
        }

        sequence() {
          const topic = this.selectedTopic();
          const path = topic ? topic.dataset.path : '';
          const names =
            path === 'commission'
              ? ['topic', 'size', 'inspiration', 'frame', 'details']
              : ['topic', 'details'];
          return names.filter((name) => this.stepMap[name]);
        }

        nextName() {
          const order = this.sequence();
          return order[order.indexOf(this.current) + 1];
        }

        show(name, direction, instant) {
          const from = this.stepMap[this.current];
          const to = this.stepMap[name];
          if (!to || to === from) return;

          if (name === 'details') this.syncDetails();

          const reduced =
            instant ||
            (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

          // Read the height as it looks right now — which may be a value locked
          // in by a transition that hasn't finished — so the animation starts
          // from what's on screen.
          const start = this.viewport.getBoundingClientRect().height;

          from.hidden = true;
          to.hidden = false;
          this.current = name;
          this.syncReady(to);

          // Now that the step is on screen, size any auto-grow field it holds —
          // this is where the message box gets its real height back.
          to.querySelectorAll('[data-sqsh-grow]').forEach((field) => this.grow(field));

          const heading = to.querySelector('[data-sqsh-heading]');
          // On a deep-link jump the page is still settling its own scroll, so
          // don't grab focus or pull the view around — just present the step.
          if (heading && !instant) heading.focus({ preventScroll: true });
          if (!instant) this.keepInView();

          // Clear any leftover locked height BEFORE measuring, so the target is
          // always the new step's true content height and never a stale value
          // carried over from an earlier, taller or shorter step.
          this.viewport.style.height = '';
          if (reduced) {
            this.viewport.classList.remove('is-animating');
            return;
          }

          const end = this.viewport.offsetHeight;
          to.classList.remove('is-entering', 'is-entering--back');
          void to.offsetWidth;
          to.classList.add(direction === 'back' ? 'is-entering--back' : 'is-entering');

          const frame = window.requestAnimationFrame || ((fn) => setTimeout(fn, 16));
          this.viewport.classList.add('is-animating');
          this.viewport.style.height = start + 'px';
          frame(() => {
            this.viewport.style.height = end + 'px';
          });

          // Release the fixed height once the transition ends; a timeout backs
          // it up in case transitionend never fires. Either way the viewport is
          // left at auto height, so nothing can stay clipped.
          const release = () => {
            this.viewport.style.height = '';
            this.viewport.classList.remove('is-animating');
            this.viewport.removeEventListener('transitionend', onEnd);
          };
          const onEnd = (event) => {
            if (event.propertyName === 'height') release();
          };
          this.viewport.addEventListener('transitionend', onEnd);
          clearTimeout(this._heightTimer);
          this._heightTimer = setTimeout(release, 600);
        }

        // Longer steps can push the buttons out of sight; bring the form back to
        // the top of the screen when that happens.
        keepInView() {
          const box = this.getBoundingClientRect();
          if (box.top < 0 || box.top > window.innerHeight * 0.6) {
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }

        syncReady(step) {
          if (!step) return;
          const group = step.querySelector('[data-sqsh-choice]');
          const next = step.querySelector('[data-sqsh-next]');
          if (!group || !next) return;
          const chosen = !!group.querySelector('input[type="radio"]:checked');
          next.classList.toggle('is-ready', chosen);
        }

        syncCustom() {
          const custom = this.querySelector('[data-sqsh-custom]');
          const input = this.querySelector('[data-sqsh-custom-input]');
          if (!custom || !input) return;

          if (custom.checked) {
            input.setAttribute('data-sqsh-require', '');
            if (document.activeElement !== input) input.focus({ preventScroll: true });
          } else {
            input.removeAttribute('data-sqsh-require');
            this.setError(input, '');
          }
        }

        // The last step carries whichever question the chosen path asks for.
        syncDetails() {
          const topic = this.selectedTopic();
          if (!topic) return;

          if (this.detailsHeading) {
            this.detailsHeading.textContent =
              topic.dataset.detailsHeading || this.dataset.detailsHeading || 'Almost there!';
          }

          const question = (topic.dataset.reference || '').trim();
          if (this.reference && this.referenceInput) {
            this.reference.hidden = !question;
            this.referenceInput.disabled = !question;
            if (question) {
              this.referenceInput.placeholder = question;
              this.referenceInput.setAttribute('data-sqsh-require', '');
              if (this.referenceLabel) this.referenceLabel.textContent = question;
            } else {
              this.referenceInput.removeAttribute('data-sqsh-require');
              this.setError(this.referenceInput, '');
            }
          }

          if (this.message) {
            const required = topic.dataset.requireMessage === 'true';
            if (required) {
              this.message.setAttribute('data-sqsh-require', '');
              this.message.placeholder = this.dataset.labelMessage || 'Message';
            } else {
              this.message.removeAttribute('data-sqsh-require');
              this.message.placeholder = this.dataset.labelMessageOptional || 'Message (Optional)';
              this.setError(this.message, '');
            }
          }
        }

        /* ---------- validation ---------- */

        validate(step) {
          if (!step) return true;
          let firstProblem = null;

          step.querySelectorAll('[data-sqsh-choice]').forEach((group) => {
            if (group.querySelector('input[type="radio"]:checked')) return;
            const note = step.querySelector('[data-sqsh-choice-error]');
            if (note) {
              note.textContent = 'Please pick one of the options above.';
              note.hidden = false;
            }
            if (!firstProblem) firstProblem = group.querySelector('input[type="radio"]');
          });

          step.querySelectorAll('[data-sqsh-field]').forEach((field) => {
            if (field.disabled) return;
            if (field.closest('[hidden]')) return;
            if (this.check(field)) return;
            if (!firstProblem) firstProblem = field;
          });

          if (firstProblem) {
            this.announce('Something on this step still needs your attention.');
            firstProblem.focus({ preventScroll: false });
            return false;
          }
          return true;
        }

        check(field) {
          const value = (field.value || '').trim();
          let message = '';

          if (!value) {
            if (field.hasAttribute('data-sqsh-require')) {
              message = field.dataset.error || 'Please fill in this field.';
            }
          } else if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
            message = field.dataset.errorFormat || 'Please check your e-mail address.';
          }

          this.setError(field, message);
          return message === '';
        }

        setError(field, message) {
          const target = field.getAttribute('aria-describedby');
          const note = target ? document.getElementById(target) : null;

          if (message) {
            field.setAttribute('aria-invalid', 'true');
            if (note) {
              note.textContent = message;
              note.hidden = false;
            }
          } else {
            field.removeAttribute('aria-invalid');
            if (note) {
              note.textContent = '';
              note.hidden = true;
            }
          }
        }

        clearChoiceError(group) {
          const step = group.closest('[data-sqsh-step]');
          const note = step && step.querySelector('[data-sqsh-choice-error]');
          if (note) {
            note.textContent = '';
            note.hidden = true;
          }
        }

        /* ---------- inspiration images ---------- */

        addFiles(list) {
          list.forEach((file) => {
            if (file.type.indexOf('image/') !== 0) return;
            if (this.files.length >= this.maxImages) return;
            this.files.push({ file: file, url: URL.createObjectURL(file) });
          });
          this.renderThumbs();
        }

        renderThumbs() {
          if (!this.thumbs) return;
          this.thumbs.innerHTML = '';

          this.files.forEach((item, index) => {
            const li = document.createElement('li');
            li.className = 'sqsh-contact-flow__thumb';

            const img = document.createElement('img');
            img.src = item.url;
            img.alt = item.file.name;

            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'sqsh-contact-flow__thumb-remove';
            remove.setAttribute('aria-label', 'Remove ' + item.file.name);
            const glyph = document.createElement('span');
            glyph.setAttribute('aria-hidden', 'true');
            glyph.textContent = '\u00d7';
            remove.appendChild(glyph);
            remove.addEventListener('click', () => {
              URL.revokeObjectURL(item.url);
              this.files.splice(index, 1);
              this.renderThumbs();
              if (this.addButton) this.addButton.focus();
            });

            li.appendChild(img);
            li.appendChild(remove);
            this.thumbs.appendChild(li);
          });

          if (this.addButton) this.addButton.hidden = this.files.length >= this.maxImages;
          this.announce(this.files.length + ' inspiration image(s) added.');
        }

        // Optional: post each image to an unsigned upload endpoint (Cloudinary
        // and friends) and send the links along with the message. Left empty in
        // the editor, the form simply lists the file names instead.
        uploadFiles() {
          const url = this.dataset.uploadUrl;
          const preset = this.dataset.uploadPreset;
          const jobs = this.files.map((item) => {
            const body = new FormData();
            body.append('file', item.file);
            if (preset) body.append('upload_preset', preset);
            return fetch(url, { method: 'POST', body: body })
              .then((response) => response.json())
              .then((data) => (data && (data.secure_url || data.url || data.link)) || '')
              .catch(() => '');
          });
          return Promise.all(jobs).then((links) => links.filter(Boolean));
        }

        writeImages(links) {
          if (!this.imagesField) return;
          if (links && links.length) {
            this.imagesField.value = links.join('\n');
          } else if (this.files.length) {
            this.imagesField.value = this.files.map((item) => item.file.name).join(', ');
          }
        }

        /* ---------- submit ---------- */

        handleSubmit(event) {
          const step = this.stepMap.details;
          if (!this.validate(step)) {
            event.preventDefault();
            return;
          }

          // Re-entry after the images finished uploading: they're on the hidden
          // field now, so let this pass straight through as a normal submit —
          // which is what lets Shopify's captcha attach its token.
          if (this._readyToPost) {
            this._readyToPost = false;
            this.prune();
            this.setBusy(true);
            return;
          }

          if (this.files.length && this.dataset.uploadUrl) {
            event.preventDefault();
            this.setBusy(true);
            this.announce('Sending your request.');
            this.uploadFiles()
              .then((links) => this.writeImages(links))
              .catch(() => this.writeImages([]))
              .then(() => {
                this._readyToPost = true;
                // requestSubmit fires a real submit event (so the captcha wireup
                // runs); a native submit() would skip it and bounce to the
                // challenge page. Fall back only where requestSubmit is missing.
                if (typeof this.form.requestSubmit === 'function') {
                  this.form.requestSubmit(this.submitButton || undefined);
                } else {
                  this._readyToPost = false;
                  this.prune();
                  this.form.submit();
                }
              });
            return;
          }

          this.writeImages([]);
          this.prune();
          this.setBusy(true);
          this.announce('Sending your request.');
        }

        // Fields belonging to a path the visitor never took would otherwise turn
        // up as empty lines in the e-mail.
        prune() {
          const order = this.sequence();
          this.steps.forEach((step) => {
            if (order.indexOf(step.dataset.sqshStep) !== -1) return;
            step.querySelectorAll('input, textarea, select').forEach((el) => {
              el.disabled = true;
            });
          });

          // The custom-size text only belongs in the e-mail when Custom is the
          // size that was picked; a stray value from switching away is dropped.
          const customRadio = this.querySelector('[data-sqsh-custom]');
          const customInput = this.querySelector('[data-sqsh-custom-input]');
          if (customInput && customRadio && !customRadio.checked) {
            customInput.disabled = true;
          }

          this.querySelectorAll('[data-sqsh-prune-empty]').forEach((el) => {
            if (!(el.value || '').trim()) el.disabled = true;
          });
        }

        handleBlockSelect(event) {
          const step = event.target && event.target.closest('[data-sqsh-step]');
          if (!step || step.dataset.sqshStep === this.current) return;
          this.trail.push(this.current);
          this.show(step.dataset.sqshStep, 'forward');
        }

        // Keeps the message box on one line until there's something to wrap.
        // A textarea inside a hidden step has no layout box, so its scrollHeight
        // reads as 0 — growing it then would collapse it shut. Skip until it's
        // actually on screen; show() re-grows it the moment its step appears.
        grow(field) {
          if (field.offsetParent === null && field.offsetHeight === 0) return;
          field.style.height = 'auto';
          field.style.height = field.scrollHeight + 'px';
        }

        setBusy(state) {
          if (this.submitButton) this.submitButton.setAttribute('aria-busy', String(state));
        }

        announce(message) {
          if (this.status) this.status.textContent = message;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-wall-roam"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  if (!customElements.get('sqsh-roam')) {
    customElements.define(
      'sqsh-roam',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = this.querySelector('.sqsh-roam__window');
          this.world = this.querySelector('.sqsh-roam__world');
          this.items = Array.from(this.querySelectorAll('.sqsh-roam__item'));
          if (!this.world || !this.items.length) return;

          this.hint = this.querySelector('.sqsh-roam__hint');

          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.fine = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.small = window.matchMedia('(max-width: 749px)');

          this.follow = (parseFloat(this.dataset.follow) || 8) / 100;
          this.depth = (parseFloat(this.dataset.depth) || 0) / 100;
          this.dragEnabled = this.dataset.drag === 'true';

          this.margin = parseFloat(this.dataset.margin);
          if (isNaN(this.margin)) this.margin = 200;

          // How much further than the world each frame drifts, by its depth.
          this.factors = this.items.map(
            function (item) {
              var d = parseFloat(item.dataset.depth);
              if (isNaN(d)) d = 50;
              return ((d - 50) / 50) * 0.18 * this.depth;
            }.bind(this)
          );

          this.target = { x: 0, y: 0 };
          this.pan = { x: 0, y: 0 };
          this.base = { x: 0, y: 0 };
          this.max = { x: 0, y: 0 };
          this.touched = false;
          this.visible = false;
          this.raf = null;
          this.drag = null;

          this._onPointerMove = this._onPointerMove.bind(this);
          this._onScroll = this._onScroll.bind(this);
          this._onResize = this._onResize.bind(this);
          this._onDown = this._onDown.bind(this);
          this._onDrag = this._onDrag.bind(this);
          this._onUp = this._onUp.bind(this);
          this._tick = this._tick.bind(this);

          this._measure();
          this._observe();
          this._bind();

          requestAnimationFrame(
            function () {
              this.classList.add('is-ready');
              this._measure();
              if (this.small.matches) this._scrollPan();
              this._start();
            }.bind(this)
          );

          // Frames can settle late once the artwork paints — measure again.
          if (document.readyState !== 'complete') {
            window.addEventListener(
              'load',
              function () {
                this._measure();
                this._start();
              }.bind(this),
              { once: true }
            );
          }

          // In the theme editor, travel to whichever frame the merchant selects.
          this._onBlockSelect = function (event) {
            var item = null;
            for (var i = 0; i < this.items.length; i++) {
              var match = this.items[i] === event.target || this.items[i].contains(event.target);
              this.items[i].classList.toggle('is-selected', match);
              if (match) item = this.items[i];
            }
            if (item) this._focus(item);
          }.bind(this);

          this._onBlockDeselect = function () {
            this.items.forEach(function (item) {
              item.classList.remove('is-selected');
            });
          }.bind(this);

          document.addEventListener('shopify:block:select', this._onBlockSelect);
          document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        }

        disconnectedCallback() {
          window.removeEventListener('pointermove', this._onPointerMove);
          window.removeEventListener('scroll', this._onScroll);
          window.removeEventListener('resize', this._onResize);
          this.removeEventListener('pointerdown', this._onDown);
          this.removeEventListener('pointermove', this._onDrag);
          this.removeEventListener('pointerup', this._onUp);
          this.removeEventListener('pointercancel', this._onUp);
          document.removeEventListener('shopify:block:select', this._onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
          if (this.io) this.io.disconnect();
          if (this.raf) cancelAnimationFrame(this.raf);
        }

        _bind() {
          window.addEventListener('pointermove', this._onPointerMove, { passive: true });
          window.addEventListener('scroll', this._onScroll, { passive: true });
          window.addEventListener('resize', this._onResize, { passive: true });
          this.addEventListener('pointerdown', this._onDown, { passive: true });
          this.addEventListener('pointermove', this._onDrag, { passive: true });
          this.addEventListener('pointerup', this._onUp, { passive: true });
          this.addEventListener('pointercancel', this._onUp, { passive: true });
        }

        _observe() {
          if (!('IntersectionObserver' in window)) {
            this.visible = true;
            return;
          }
          this.io = new IntersectionObserver(
            function (entries) {
              this.visible = entries[0].isIntersecting;
              if (this.visible) this._start();
            }.bind(this),
            { rootMargin: '10% 0px' }
          );
          this.io.observe(this);
        }

        /* Travel is measured from the paintings themselves, not from the world
           around them — so the wall stops at the outermost frame and you never
           roam off into empty space — it stops with the margin still showing. */
        _measure() {
          var box = this.frame || this;
          var w = box.offsetWidth;
          var h = box.offsetHeight;
          // Generous, but never so wide that it swallows a small screen.
          var pad = Math.min(this.margin, Math.min(w, h) * 0.38);
          var minX = Infinity;
          var maxX = -Infinity;
          var minY = Infinity;
          var maxY = -Infinity;

          for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            var halfW = item.offsetWidth / 2;
            var halfH = item.offsetHeight / 2;
            if (item.offsetLeft - halfW < minX) minX = item.offsetLeft - halfW;
            if (item.offsetLeft + halfW > maxX) maxX = item.offsetLeft + halfW;
            if (item.offsetTop - halfH < minY) minY = item.offsetTop - halfH;
            if (item.offsetTop + halfH > maxY) maxY = item.offsetTop + halfH;
          }

          if (!isFinite(minX)) {
            minX = 0;
            maxX = this.world.offsetWidth;
            minY = 0;
            maxY = this.world.offsetHeight;
          }

          minX -= pad;
          maxX += pad;
          minY -= pad;
          maxY += pad;

          // Where the wall sits when the whole group is centred in the window.
          this.base.x = this.world.offsetWidth / 2 - (minX + maxX) / 2;
          this.base.y = this.world.offsetHeight / 2 - (minY + maxY) / 2;

          this.max.x = Math.max(0, (maxX - minX - w) / 2);
          this.max.y = Math.max(0, (maxY - minY - h) / 2);

          if (!this.touched) {
            this.target.x = this.base.x;
            this.target.y = this.base.y;
            this.pan.x = this.base.x;
            this.pan.y = this.base.y;
          } else {
            this.target.x = this._clamp(this.target.x, this.base.x, this.max.x);
            this.target.y = this._clamp(this.target.y, this.base.y, this.max.y);
          }
        }

        _clamp(value, base, limit) {
          if (value > base + limit) return base + limit;
          if (value < base - limit) return base - limit;
          return value;
        }

        _hideHint() {
          if (this.hint && !this.hint.classList.contains('is-hidden')) {
            this.hint.classList.add('is-hidden');
          }
        }

        /* Desktop: the cursor's place on the screen picks the place in the
           gallery. Left edge shows the left of the wall, and so on. */
        _onPointerMove(event) {
          if (this.small.matches || !this.fine.matches) return;
          var rect = (this.frame || this).getBoundingClientRect();
          if (!rect.width || !rect.height) return;

          var px = (event.clientX - rect.left) / rect.width;
          var py = (event.clientY - rect.top) / rect.height;
          px = Math.min(1, Math.max(0, px));
          py = Math.min(1, Math.max(0, py));

          this.touched = true;
          this.target.x = this.base.x - (px * 2 - 1) * this.max.x;
          this.target.y = this.base.y - (py * 2 - 1) * this.max.y;

          this._hideHint();
          if (this.visible) this._start();
        }

        /* Mobile: scrolling walks down the wall. When dragging is off, it
           wanders sideways on the way through as well. */
        _scrollPan() {
          var rect = this.getBoundingClientRect();
          var vh = window.innerHeight || 1;
          var progress = (vh - rect.top) / (vh + rect.height);
          progress = Math.min(1, Math.max(0, progress));

          this.touched = true;
          this.target.y = this.base.y + (0.5 - progress) * 2 * this.max.y;
          if (!this.dragEnabled) {
            this.target.x = this.base.x + Math.sin(progress * Math.PI * 2) * this.max.x * 0.7;
          }
        }

        _onScroll() {
          if (!this.small.matches || !this.visible || this.drag) return;
          this._scrollPan();
          this._start();
        }

        _onResize() {
          this._measure();
          if (this.small.matches) this._scrollPan();
          this._start();
        }

        _onDown(event) {
          if (!this.small.matches || !this.dragEnabled) return;
          this.drag = { id: event.pointerId, x: event.clientX, from: this.target.x };
          this.classList.add('is-dragging');
          this._hideHint();
        }

        _onDrag(event) {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          var moved = (event.clientX - this.drag.x) * 1.4;
          this.touched = true;
          this.target.x = this._clamp(this.drag.from + moved, this.base.x, this.max.x);
          this._start();
        }

        _onUp() {
          if (!this.drag) return;
          this.drag = null;
          this.classList.remove('is-dragging');
        }

        /* Bring one painting to the middle of the window. */
        _focus(item) {
          this._measure();
          this.touched = true;
          this.target.x = this._clamp(
            this.world.offsetWidth / 2 - item.offsetLeft,
            this.base.x,
            this.max.x
          );
          this.target.y = this._clamp(
            this.world.offsetHeight / 2 - item.offsetTop,
            this.base.y,
            this.max.y
          );
          this._start();
        }

        _start() {
          if (this.raf) return;
          this.raf = requestAnimationFrame(this._tick);
        }

        _tick() {
          this.raf = null;

          // Reduced motion still travels — it just arrives without the glide.
          var ease = this.reduce.matches ? 1 : this.follow;
          this.pan.x += (this.target.x - this.pan.x) * ease;
          this.pan.y += (this.target.y - this.pan.y) * ease;

          this.world.style.setProperty('--sqsh-pan-x', this.pan.x.toFixed(2) + 'px');
          this.world.style.setProperty('--sqsh-pan-y', this.pan.y.toFixed(2) + 'px');

          if (this.depth > 0 && !this.small.matches && !this.reduce.matches) {
            for (var i = 0; i < this.items.length; i++) {
              var f = this.factors[i];
              if (!f) continue;
              this.items[i].style.setProperty('--sqsh-tx', (this.pan.x * f).toFixed(2) + 'px');
              this.items[i].style.setProperty('--sqsh-ty', (this.pan.y * f).toFixed(2) + 'px');
            }
          }

          var settled =
            Math.abs(this.target.x - this.pan.x) < 0.2 && Math.abs(this.target.y - this.pan.y) < 0.2;
          if (!settled && this.visible) this._start();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-wall"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  if (!customElements.get('sqsh-gallery')) {
    customElements.define(
      'sqsh-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.sqsh-gallery__item'));
          if (!this.items.length) return;

          this.cta = this.querySelector('.sqsh-gallery__cta');
          this.stickRaf = null;

          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.fine = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.small = window.matchMedia('(max-width: 749px)');

          this.strength = (parseFloat(this.dataset.parallax) || 0) / 100;
          this.mobileMotion = this.dataset.mobileMotion === 'true';

          this.pointer = { x: 0, y: 0 };
          this.state = this.items.map(function (item) {
            var depth = (parseFloat(item.dataset.depth) || 50) / 100;
            return { x: 0, y: 0, tx: 0, ty: 0, factor: 0.35 + depth };
          });

          this.visible = false;
          this.raf = null;

          this._onPointerMove = this._onPointerMove.bind(this);
          this._onScroll = this._onScroll.bind(this);
          this._onResize = this._onResize.bind(this);
          this._tick = this._tick.bind(this);

          this._observe();
          this._bind();

          // Reveal the wall once it comes into view.
          requestAnimationFrame(
            function () {
              this.classList.add('is-ready');
              if (this._isMobile()) {
                this._mobileFrame();
              } else {
                this._clearMobileVars();
                this._fit();
              }
              this._stickCta();
            }.bind(this)
          );

          // Re-measure once images have painted, in case frame heights settle late.
          if (document.readyState !== 'complete') {
            window.addEventListener('load', function () {
              if (!this._isMobile()) this._fit();
              this._stickCta();
            }.bind(this), { once: true });
          }

          // Highlight whichever frame the merchant selects in the editor.
          this._onBlockSelect = function (event) {
            this.items.forEach(function (item) {
              item.classList.toggle('is-selected', item === event.target || item.contains(event.target));
            });
          }.bind(this);
          this._onBlockDeselect = function () {
            this.items.forEach(function (item) {
              item.classList.remove('is-selected');
            });
          }.bind(this);
          document.addEventListener('shopify:block:select', this._onBlockSelect);
          document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        }

        disconnectedCallback() {
          window.removeEventListener('pointermove', this._onPointerMove);
          window.removeEventListener('scroll', this._onScroll);
          window.removeEventListener('resize', this._onResize);
          document.removeEventListener('shopify:block:select', this._onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
          if (this.io) this.io.disconnect();
          if (this.raf) cancelAnimationFrame(this.raf);
          if (this.stickRaf) cancelAnimationFrame(this.stickRaf);
        }

        _isMobile() {
          return this.small.matches;
        }

        _motionOff() {
          return this.reduce.matches;
        }

        _observe() {
          if (!('IntersectionObserver' in window)) {
            this.visible = true;
            return;
          }
          this.io = new IntersectionObserver(
            function (entries) {
              this.visible = entries[0].isIntersecting;
              if (this.visible) this._start();
            }.bind(this),
            { rootMargin: '10% 0px' }
          );
          this.io.observe(this);
        }

        _bind() {
          window.addEventListener('pointermove', this._onPointerMove, { passive: true });
          window.addEventListener('scroll', this._onScroll, { passive: true });
          window.addEventListener('resize', this._onResize, { passive: true });
        }

        _onPointerMove(event) {
          if (this._isMobile() || this._motionOff() || !this.fine.matches || !this.visible) return;
          // -1 → 1 across the viewport, measured from the middle.
          this.pointer.x = (event.clientX / window.innerWidth - 0.5) * 2;
          this.pointer.y = (event.clientY / window.innerHeight - 0.5) * 2;
          this._start();
        }

        _onScroll() {
          if (this.stickRaf) return;
          this.stickRaf = requestAnimationFrame(
            function () {
              this.stickRaf = null;
              this._stickCta();
              // Mobile also zooms the paintings as they pass the middle.
              if (this._isMobile() && this.mobileMotion && !this._motionOff() && this.visible) {
                this._mobileFrame();
              }
            }.bind(this)
          );
        }

        _onResize() {
          this._reset();
          if (this._isMobile()) {
            this.style.height = '';
            this.style.removeProperty('--sqsh-shift-y');
            this._mobileFrame();
          } else {
            this._clearMobileVars();
            this._fit();
          }
          this._stickCta();
        }

        /* Strip any inline values the mobile scroll-effect left behind, so a
           stale --sqsh-dim / scale / rotation can't wash out or shift the
           desktop frames after a resize or editor device switch. */
        _clearMobileVars() {
          for (var i = 0; i < this.items.length; i++) {
            var st = this.items[i].style;
            st.removeProperty('--sqsh-dim');
            st.removeProperty('--sqsh-scale-mob');
            st.removeProperty('--sqsh-rot');
          }
        }

        /* The button starts its offset from the section's top-right, then holds
           that same distance above the bottom of the viewport as you scroll
           through the section, and finally rests near the section's bottom.
           It's absolutely positioned, so this never affects the paintings. */
        _stickCta() {
          if (!this.cta) return;
          var pad = this._isMobile() ? 20 : 100;
          var rect = this.getBoundingClientRect();
          var btnH = this.cta.offsetHeight;
          var sectionH = this.offsetHeight;
          var top = (window.innerHeight - btnH - pad) - rect.top;
          var lo = pad;
          var hi = sectionH - btnH - pad;
          if (hi < lo) hi = lo;
          if (top < lo) top = lo;
          if (top > hi) top = hi;
          this.cta.style.setProperty('--sqsh-cta-top', top.toFixed(1) + 'px');
        }

        /* Measure the paintings and make the section exactly tall enough to hold
           them. Reads resolved CSS positions (not live rects) so cursor parallax
           never makes the height jitter. Also nudges everything down if a raised
           painting would otherwise clip past the top edge. */
        _fit() {
          if (this._isMobile()) {
            this.style.height = '';
            this.style.removeProperty('--sqsh-shift-y');
            return;
          }

          var padTop = 48;
          var padBottom = 56;
          var minTop = Infinity;
          var maxBottom = 0;

          for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            var topPx = parseFloat(window.getComputedStyle(item).top) || 0;
            var half = item.offsetHeight / 2; // item is centered on its top via translate(-50%)
            var t = topPx - half;
            var b = topPx + half;
            if (t < minTop) minTop = t;
            if (b > maxBottom) maxBottom = b;
          }

          var shift = 0;
          if (minTop < padTop) shift = padTop - minTop;
          this.style.setProperty('--sqsh-shift-y', shift.toFixed(2) + 'px');
          this.style.height = (maxBottom + shift + padBottom).toFixed(2) + 'px';
        }

        _reset() {
          this.items.forEach(
            function (item, index) {
              this.state[index].x = 0;
              this.state[index].y = 0;
              this.state[index].tx = 0;
              this.state[index].ty = 0;
              item.style.removeProperty('--sqsh-tx');
              item.style.removeProperty('--sqsh-ty');
              item.style.removeProperty('--sqsh-rot');
              item.style.removeProperty('--sqsh-scale-mob');
              item.style.removeProperty('--sqsh-dim');
            }.bind(this)
          );
        }

        _start() {
          if (this.raf) return;
          this.raf = requestAnimationFrame(this._tick);
        }

        _tick() {
          this.raf = null;
          if (this._isMobile()) {
            this._mobileFrame();
            return;
          }
          this._desktopFrame();
        }

        /* Paintings drift against the cursor, nearer ones travelling further. */
        _desktopFrame() {
          if (this._motionOff() || !this.fine.matches) return;

          var settled = true;
          var reachX = 52 * this.strength;
          var reachY = 30 * this.strength;

          for (var i = 0; i < this.items.length; i++) {
            var s = this.state[i];
            s.tx = -this.pointer.x * reachX * s.factor;
            s.ty = -this.pointer.y * reachY * s.factor;
            s.x += (s.tx - s.x) * 0.075;
            s.y += (s.ty - s.y) * 0.075;

            this.items[i].style.setProperty('--sqsh-tx', s.x.toFixed(2) + 'px');
            this.items[i].style.setProperty('--sqsh-ty', s.y.toFixed(2) + 'px');

            if (Math.abs(s.tx - s.x) > 0.15 || Math.abs(s.ty - s.y) > 0.15) settled = false;
          }

          if (!settled && this.visible) this._start();
        }

        /* Mobile: each painting swells as it passes the middle of the screen,
           and drifts sideways on the way past — a walk down the wall. */
        _mobileFrame() {
          var viewport = window.innerHeight;
          var middle = viewport / 2;
          var live = this.mobileMotion && !this._motionOff();

          for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];

            if (!live) {
              item.style.setProperty('--sqsh-scale-mob', '1');
              item.style.setProperty('--sqsh-dim', '1');
              continue;
            }

            var rect = item.getBoundingClientRect();
            var centre = rect.top + rect.height / 2;
            var distance = (centre - middle) / viewport; // 0 at the middle
            var near = Math.max(0, 1 - Math.abs(distance) * 1.9);

            var scale = 1 + near * 0.16;
            var dim = 0.78 + near * 0.22;
            var drift = distance * 20 * (item.dataset.side === 'l' ? -1 : 1);
            var rotation = distance * (item.dataset.side === 'l' ? -1.6 : 1.6);

            item.style.setProperty('--sqsh-scale-mob', scale.toFixed(3));
            item.style.setProperty('--sqsh-dim', dim.toFixed(3));
            item.style.setProperty('--sqsh-tx', drift.toFixed(2) + 'px');
            item.style.setProperty('--sqsh-rot', rotation.toFixed(2) + 'deg');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sqsh-site-header')) {
    customElements.define(
      'sqsh-site-header',
      class extends HTMLElement {
        connectedCallback() {
          this.spacer = this.parentElement
            ? this.parentElement.querySelector('.sqsh-header__spacer')
            : null;

          this._onScroll = this._onScroll.bind(this);
          this._onResize = this._onResize.bind(this);
          this._detectHero = this._detectHero.bind(this);
          this._raf = null;
          this._hiddenLayers = [];

          this._detectHero();

          // The hero sits below this section in the DOM, so it may not exist yet.
          // Re-check when the document finishes parsing, when a hero announces
          // itself, and when the theme editor re-renders any section.
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this._detectHero, { once: true });
          }
          document.addEventListener('sqsh:hero-ready', this._detectHero);
          document.addEventListener('shopify:section:load', this._detectHero);
          document.addEventListener('shopify:section:unload', this._detectHero);

          window.addEventListener('resize', this._onResize, { passive: true });

          this._setupCartLinks();
          this._setupDrawer();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this._onScroll);
          window.removeEventListener('resize', this._onResize);
          document.removeEventListener('DOMContentLoaded', this._detectHero);
          document.removeEventListener('sqsh:hero-ready', this._detectHero);
          document.removeEventListener('shopify:section:load', this._detectHero);
          document.removeEventListener('shopify:section:unload', this._detectHero);
          document.removeEventListener('keydown', this._onKeydown);

          // The drawer may be parked on <body>. If this header goes away (theme
          // editor re-render), take it with us or it's orphaned there forever.
          this._restoreLayers();
          document.documentElement.classList.remove('sqsh-scroll-lock');
          if (this.drawer && this.drawer.parentElement === document.body) {
            this.drawer.remove();
          }
        }

        /* ---------- Cart links ----------
           Dawn only wires up #cart-icon-bubble, which is hidden here. These are
           the links people actually see, so open the drawer from them too. If no
           working drawer exists the listener bails and the link navigates to
           /cart as normal. */
        _setupCartLinks() {
          this.querySelectorAll('.sqsh-header__cart').forEach((link) => {
            link.addEventListener('click', (event) => {
              const drawer = document.querySelector('cart-drawer');
              if (!drawer || typeof drawer.open !== 'function') return;
              event.preventDefault();
              if (this.drawer && this.drawer.classList.contains('is-open')) this.closeMenu();
              drawer.open(link);
            });
          });
        }

        /* ---------- Hero detection ----------
           Runs more than once, so it has to be able to undo its own decisions:
           a template can gain a hero (editor re-render) or lose one. */
        _detectHero() {
          // Either hero puts the header over imagery. Only the morphing one
          // (homepage) brings its own logo along.
          this.morphHero = document.querySelector('sqsh-hero, .sqsh-hero');
          this.hero =
            this.morphHero ||
            document.querySelector('sqsh-page-hero, .sqsh-page-hero, [data-sqsh-hero]');

          this.classList.toggle('sqsh-morph-hero', !!this.morphHero);
          // Show the header's own mobile logo whenever the morphing hero (the
          // only source of a docked logo) is absent — i.e. every page but home.
          this.classList.toggle('sqsh-show-mobile-logo', !this.morphHero);

          this.overlay = this.dataset.overlay === 'true';

          if (this.overlay && !this.hero) {
            // No hero on this template: fall back to a normal solid header.
            this.overlay = false;
            this.classList.add('sqsh-no-hero', 'is-solid');
            window.removeEventListener('scroll', this._onScroll);
          } else if (this.overlay) {
            this.classList.remove('sqsh-no-hero', 'is-solid');
            // Same bound reference every time, so this never stacks up.
            window.addEventListener('scroll', this._onScroll, { passive: true });
            this._apply();
          }

          this.syncSpacer();
        }

        /* ---------- Mobile drawer ---------- */
        _setupDrawer() {
          this.explore = this.querySelector('.sqsh-header__mobile .sqsh-header__explore');
          this.drawer = this.querySelector('.sqsh-drawer');
          if (!this.explore || !this.drawer) return;

          this._onKeydown = (e) => {
            if (e.key === 'Escape') this.closeMenu();
          };

          this.explore.addEventListener('click', () => {
            if (this.drawer.classList.contains('is-open')) this.closeMenu();
            else this.openMenu();
          });

          this.drawer.addEventListener('click', (e) => {
            if (e.target.closest('.sqsh-drawer__close')) {
              e.preventDefault();
              this.closeMenu();
            } else if (e.target.closest('.sqsh-drawer__link')) {
              this.closeMenu();
            }
          });
        }

        /* Move the drawer to <body>.
           Shopify's #shopify-section-… wrapper around this header can create a
           stacking context; when it does, the drawer's z-index only competes
           with its siblings inside that wrapper, so fixed elements from other
           sections paint straight over it. As a direct child of <body> its
           z-index finally counts against the whole page. Done once, on first
           open, and undone in disconnectedCallback. */
        _portalDrawer() {
          if (this.drawer && this.drawer.parentElement !== document.body) {
            document.body.appendChild(this.drawer);
          }
        }

        /* Belt and braces: hide the hero layers outright while the menu is open,
           in case one of them is fixed with a z-index of its own. visibility
           doesn't affect layout, and every change is recorded so it can be put
           back exactly as it was. */
        _hideLayers() {
          this._hiddenLayers = [];
          document
            .querySelectorAll('sqsh-hero, .sqsh-hero, sqsh-page-hero, .sqsh-page-hero, [data-sqsh-hero]')
            .forEach((el) => {
              this._hiddenLayers.push([el, el.style.visibility]);
              el.style.visibility = 'hidden';
            });
        }

        _restoreLayers() {
          (this._hiddenLayers || []).forEach(([el, value]) => {
            el.style.visibility = value || '';
          });
          this._hiddenLayers = [];
        }

        openMenu() {
          this._portalDrawer();
          this._hideLayers();
          // Next frame, so the browser paints the drawer off-screen first and
          // the slide-in transition actually runs after the move.
          requestAnimationFrame(() => {
            this.drawer.classList.add('is-open');
          });
          this.drawer.setAttribute('aria-hidden', 'false');
          this.classList.add('sqsh-menu-open');
          this.explore.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('sqsh-scroll-lock');
          document.addEventListener('keydown', this._onKeydown);
          const close = this.drawer.querySelector('.sqsh-drawer__close');
          if (close) close.focus();
        }

        closeMenu() {
          this.drawer.classList.remove('is-open');
          this.drawer.setAttribute('aria-hidden', 'true');
          this.classList.remove('sqsh-menu-open');
          this.explore.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('sqsh-scroll-lock');
          document.removeEventListener('keydown', this._onKeydown);
          this._restoreLayers();
          this.explore.focus();
        }

        syncSpacer() {
          const h = this.offsetHeight;
          document.documentElement.style.setProperty('--header-height', h + 'px');
          if (this.spacer) {
            this.spacer.style.height = this.overlay ? '0px' : h + 'px';
          }
        }

        // Switch point: where the bottom of the header meets the bottom of the
        // hero, i.e. the moment the header fully clears the hero section.
        // Measured live so a hero that grows (late-loading video, resize) is fine.
        _threshold() {
          const headerH = this.offsetHeight;
          if (this.hero) {
            const heroBottom =
              this.hero.getBoundingClientRect().bottom + window.pageYOffset;
            return Math.max(heroBottom - headerH, 0);
          }
          return Math.max(window.innerHeight - headerH, 0);
        }

        _apply() {
          this.classList.toggle('is-solid', window.pageYOffset > this._threshold());
        }

        _onScroll() {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => {
            this._raf = null;
            this._apply();
          });
        }

        _onResize() {
          this.syncSpacer();
          if (this.overlay) this._apply();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  if (!customElements.get('sqsh-hero')) {
    customElements.define(
      'sqsh-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('.sqsh-hero__video');
          this.logo = this.querySelector('.sqsh-hero__logo');
          this.img = this.querySelector('.sqsh-hero__logo-img');

          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.heroLogoW = parseFloat(this.dataset.heroLogoWidth) || 300;
          this.dockedLogoW = parseFloat(this.dataset.dockedLogoWidth) || 130;
          this.dockedLogoWMobile = parseFloat(this.dataset.dockedLogoWidthMobile) || this.dockedLogoW;
          this.dockedOffset = parseFloat(this.dataset.dockedOffset) || 34;
          this.dockTopMobile = parseFloat(this.dataset.dockTopMobile) || 20;

          this._onScroll = this._onScroll.bind(this);
          this._onResize = this._onResize.bind(this);
          this._raf = null;

          // Pull the hero up behind a transparent header, closing any gap the
          // theme reserves above the first section.
          this.overlayHeader = document.querySelector('.sqsh-site-header--overlay');
          this.pullToTop();

          this._setupVideo();

          if (this.logo && this.img) {
            const start = () => {
              this.pullToTop();
              this.measure();
              this.update();
              this.classList.add('is-ready');
            };
            if (this.img.complete) {
              start();
            } else {
              this.img.addEventListener('load', start, { once: true });
              this.img.addEventListener('error', start, { once: true });
              setTimeout(start, 600); // safety net if load never fires
            }
            window.addEventListener('scroll', this._onScroll, { passive: true });
          }

          window.addEventListener('resize', this._onResize, { passive: true });
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this._onScroll);
          window.removeEventListener('resize', this._onResize);
        }

        _setupVideo() {
          if (!this.video || this.video.tagName !== 'VIDEO') return;
          this.video.muted = true;
          this.video.playsInline = true;
          this.video.setAttribute('playsinline', '');
          if (this.reduce.matches) {
            this.video.removeAttribute('autoplay');
            try { this.video.pause(); } catch (e) {}
          } else {
            const played = this.video.play();
            if (played && played.catch) played.catch(function () {});
          }
        }

        // The width the logo docks to depends on viewport: a separate, larger
        // value on mobile so the docked logo isn't tiny on small screens.
        _dockedWidth() {
          return window.innerWidth <= 749 ? this.dockedLogoWMobile : this.dockedLogoW;
        }

        pullToTop() {
          // Only when a transparent header is overlaying this hero.
          if (!this.overlayHeader) return;
          const wrapper = this.closest('.shopify-section') || this;
          wrapper.style.marginTop = '0px';
          // Measure the natural gap above the hero at the top of the page.
          const top = wrapper.getBoundingClientRect().top + window.pageYOffset;
          if (top > 0.5) {
            wrapper.style.marginTop = -top + 'px';
          }
        }

        measure() {
          const rect = this.getBoundingClientRect();
          this.heroTop = rect.top + window.pageYOffset; // document offset of the hero top
          this.heroHeight = this.offsetHeight || window.innerHeight * 0.9;
          this.morphDist = Math.max(this.heroHeight, 1);
          this.bigH = this.img ? this.img.offsetHeight : 0; // untransformed logo height
          this.bigW = this.img ? this.img.offsetWidth : this.heroLogoW; // untransformed logo width
          // Scale from the logo's REAL rendered width so the docked end lands on
          // exactly _dockedWidth() px, even when the start logo is capped (e.g.
          // 70vw on mobile). Recomputed on resize so the swap is live.
          this.smallScale = this._dockedWidth() / (this.bigW || this.heroLogoW);
        }

        update() {
          if (!this.logo) return;
          const scrollY = window.pageYOffset;
          let p = scrollY / this.morphDist;
          p = p < 0 ? 0 : p > 1 ? 1 : p;

          const scale = 1 - (1 - this.smallScale) * p;
          const isMobile = window.innerWidth <= 749;

          // Start: logo centred over the hero. End (docked): on mobile we pin the
          // logo's TOP to dockTopMobile so it lines up with the Explore/Cart row;
          // on desktop we keep the original centre-based offset.
          const startCentre = this.heroTop + this.heroHeight / 2;
          const startTop = startCentre - this.bigH / 2;

          let ty;
          if (isMobile) {
            const endTop = this.dockTopMobile;                 // top edge when docked
            ty = startTop + (endTop - startTop) * p;
          } else {
            const centreY = startCentre + (this.dockedOffset - startCentre) * p;
            ty = centreY - (this.bigH * scale) / 2;
          }

          this.logo.style.setProperty('--sqsh-logo-scale', scale.toFixed(4));
          this.logo.style.setProperty('--sqsh-logo-y', ty.toFixed(2) + 'px');
        }

        _onScroll() {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => {
            this._raf = null;
            this.update();
          });
        }

        _onResize() {
          this.pullToTop();
          this.measure();
          this.update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-hero-image"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  if (!customElements.get('sqsh-page-hero')) {
    customElements.define(
      'sqsh-page-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.mode = this.dataset.topBehavior || 'behind';
          this._onResize = this._onResize.bind(this);
          this._onScroll = this._onScroll.bind(this);
          this._onTap = this._onTap.bind(this);
          this._mq = window.matchMedia('(max-width: 749px)');

          this.collapseGap();

          // Re-measure once fonts, images and late-loading sections have settled.
          window.addEventListener('load', this._onResize);
          window.addEventListener('resize', this._onResize, { passive: true });
          // Tap anywhere on the hero to reveal colour (mobile only — see _onTap).
          this.addEventListener('click', this._onTap);

          this.setupExit();
        }

        disconnectedCallback() {
          window.removeEventListener('load', this._onResize);
          window.removeEventListener('resize', this._onResize);
          this.removeEventListener('click', this._onTap);
          this.stopWatching();
          const wrapper = this.closest('.shopify-section');
          if (wrapper) wrapper.style.marginTop = '';
        }

        // Pulls the hero up by whatever gap the theme leaves above it — whether that
        // comes from the section wrapper, the page container, or an empty block above.
        collapseGap() {
          const wrapper = this.closest('.shopify-section') || this;
          wrapper.style.marginTop = '0px';

          const y = window.pageYOffset;
          const heroTop = this.getBoundingClientRect().top + y;

          // "behind" pulls to the very top of the page, under a transparent header.
          // "below" stops at the bottom of whatever sits directly above.
          let target = 0;
          if (this.mode !== 'behind') {
            const prev = wrapper.previousElementSibling;
            if (prev) {
              target = prev.getBoundingClientRect().bottom + y;
            } else if (wrapper.parentElement) {
              target = wrapper.parentElement.getBoundingClientRect().top + y;
            }
          }

          const delta = heroTop - target;
          if (delta > 0.5) {
            wrapper.style.marginTop = -delta + 'px';
          }
        }

        _onResize() {
          this.collapseGap();
          if (this.watching) this.measure();
        }

        // The entry animation is pure CSS. This only decides when the letters leave.
        setupExit() {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.animate !== 'true' || reduced) return;

          this.exitPoint = parseFloat(this.dataset.exitPoint);
          if (isNaN(this.exitPoint)) this.exitPoint = 8;
          this.replay = this.dataset.replay === 'true';
          this.isOut = false;
          this.ticking = false;
          this.watching = true;

          // Captured on the document as well, so it still fires when the page
          // scrolls inside a wrapper element rather than the window itself.
          window.addEventListener('scroll', this._onScroll, { passive: true });
          document.addEventListener('scroll', this._onScroll, { passive: true, capture: true });
          this.measure();
        }

        stopWatching() {
          this.watching = false;
          window.removeEventListener('scroll', this._onScroll);
          document.removeEventListener('scroll', this._onScroll, true);
        }

        _onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(() => {
            this.ticking = false;
            this.measure();
          });
        }

        measure() {
          const rect = this.getBoundingClientRect();
          if (!rect.height) return;

          // Pixels the hero has travelled up past the top of the viewport, so the
          // exit fires on the first bit of scroll rather than deep into the image.
          const scrolled = -rect.top;
          const threshold = Math.max(this.exitPoint, 2);
          // A small band around the threshold so the letters don't flicker on it.
          const shouldExit = this.isOut ? scrolled > threshold - 2 : scrolled >= threshold;
          if (shouldExit === this.isOut) return;

          this.isOut = shouldExit;
          this.classList.toggle('sqsh-page-hero--out', shouldExit);

          // Coming back up, rerun the reveal rather than just fading the lines in.
          if (!shouldExit) this.restartEntry();

          // Without replay, the exit is one-way and the listeners can retire.
          if (shouldExit && !this.replay) this.stopWatching();
        }

        restartEntry() {
          this.classList.remove('sqsh-page-hero--motion');
          void this.offsetWidth; // forces the reflow that lets the animation start over
          this.classList.add('sqsh-page-hero--motion');
        }

        // Mobile only: tapping the hero toggles colour on/off. The actual
        // grayscale change and its ease-in transition live in CSS; this only
        // flips the class. Desktop taps/clicks are ignored, and there's nothing
        // to reveal unless the Black & white setting is on.
        _onTap() {
          if (!this._mq.matches) return;
          if (!this.classList.contains('sqsh-page-hero--bw')) return;
          this.classList.toggle('sqsh-page-hero--revealed');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prints-hero-image"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  if (!customElements.get('sqsh-prints-hero')) {
    customElements.define(
      'sqsh-prints-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.mode = this.dataset.topBehavior || 'behind';
          this._onResize = this._onResize.bind(this);
          this._onPointerMove = this._onPointerMove.bind(this);
          this._onPointerLeave = this._onPointerLeave.bind(this);
          this._draw = this._draw.bind(this);
          this._onHoverChange = this._onHoverChange.bind(this);
          this._onScroll = this._onScroll.bind(this);
          this._onTap = this._onTap.bind(this);
          this._mq = window.matchMedia('(max-width: 749px)');

          this.collapseGap();
          this.measure();
          // Re-measure once fonts, images and late-loading sections have settled.
          window.addEventListener('load', this._onResize);
          window.addEventListener('resize', this._onResize, { passive: true });
          // Tap anywhere on the hero to reveal colour (mobile only — see _onTap).
          this.addEventListener('click', this._onTap);

          this.setupReveal();
          this.setupExit();

          // The header renders before this section, and in the theme editor either
          // one can be re-rendered on its own — so a one-off querySelector at the
          // header's connect time will miss us. Announce instead.
          document.dispatchEvent(
            new CustomEvent('sqsh:hero-ready', { detail: { hero: this } })
          );
        }

        disconnectedCallback() {
          window.removeEventListener('load', this._onResize);
          window.removeEventListener('resize', this._onResize);
          this.removeEventListener('click', this._onTap);
          this.teardownReveal();
          this.stopWatching();
          if (this.hoverQuery && this.hoverQuery.removeEventListener) {
            this.hoverQuery.removeEventListener('change', this._onHoverChange);
          }
          const wrapper = this.closest('.shopify-section');
          if (wrapper) wrapper.style.marginTop = '';
        }

        // Pulls the hero up by whatever gap the theme leaves above it — whether that
        // comes from the section wrapper, the page container, or an empty block above.
        collapseGap() {
          const wrapper = this.closest('.shopify-section') || this;
          wrapper.style.marginTop = '0px';

          const y = window.pageYOffset;
          const heroTop = this.getBoundingClientRect().top + y;

          // "behind" pulls to the very top of the page, under a transparent header.
          // "below" stops at the bottom of whatever sits directly above.
          let target = 0;
          if (this.mode !== 'behind') {
            const prev = wrapper.previousElementSibling;
            if (prev) {
              target = prev.getBoundingClientRect().bottom + y;
            } else if (wrapper.parentElement) {
              target = wrapper.parentElement.getBoundingClientRect().top + y;
            }
          }

          const delta = heroTop - target;
          if (delta > 0.5) {
            wrapper.style.marginTop = -delta + 'px';
          }
        }

        // The reveal image is sized to the hero, not to its splat-shaped parent,
        // so it needs the hero's real pixel box.
        measure() {
          const rect = this.getBoundingClientRect();
          this.heroWidth = rect.width;
          this.heroHeight = rect.height;
          this.style.setProperty('--sqsh-prints-hero-w', rect.width + 'px');
          this.style.setProperty('--sqsh-prints-hero-h', rect.height + 'px');

          if (this.reveal) {
            const blob = this.reveal.getBoundingClientRect();
            this.blobWidth = blob.width;
            this.blobHeight = blob.height;
          }
        }

        setupReveal() {
          if (this.dataset.reveal !== 'true') return;
          this.reveal = this.querySelector('.sqsh-prints-hero__reveal');
          if (!this.reveal) return;

          // Fine pointers only. A phone or tablet keeps the hero exactly as designed.
          this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
          if (this.hoverQuery.addEventListener) {
            this.hoverQuery.addEventListener('change', this._onHoverChange);
          }
          this._onHoverChange();
        }

        _onHoverChange() {
          if (!this.reveal) return;
          if (this.hoverQuery.matches) {
            this.bindPointer();
          } else {
            this.teardownReveal();
          }
        }

        bindPointer() {
          if (this.pointerBound) return;
          this.pointerBound = true;
          this.measure();
          this.addEventListener('pointermove', this._onPointerMove, { passive: true });
          this.addEventListener('pointerleave', this._onPointerLeave, { passive: true });
        }

        teardownReveal() {
          if (!this.pointerBound) return;
          this.pointerBound = false;
          this.removeEventListener('pointermove', this._onPointerMove);
          this.removeEventListener('pointerleave', this._onPointerLeave);
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = null;
          this.classList.remove('sqsh-prints-hero--revealing');
        }

        _onPointerMove(event) {
          // Touch and pen still fire pointermove on hybrid devices — mouse only.
          if (event.pointerType && event.pointerType !== 'mouse') return;

          const rect = this.getBoundingClientRect();
          this.pointerX = event.clientX - rect.left - (this.blobWidth || 0) / 2;
          this.pointerY = event.clientY - rect.top - (this.blobHeight || 0) / 2;

          if (!this.frame) this.frame = requestAnimationFrame(this._draw);
        }

        // One write per frame, both of them transforms, so the splat stays glued
        // to the cursor without forcing a repaint of the image underneath.
        _draw() {
          this.frame = null;
          this.style.setProperty('--sqsh-prints-hero-reveal-x', this.pointerX + 'px');
          this.style.setProperty('--sqsh-prints-hero-reveal-y', this.pointerY + 'px');
          if (!this.classList.contains('sqsh-prints-hero--revealing')) {
            this.classList.add('sqsh-prints-hero--revealing');
          }
        }

        _onPointerLeave() {
          this.classList.remove('sqsh-prints-hero--revealing');
        }

        // Mobile only: tapping the hero toggles colour on/off. The actual
        // treatment change and its ease-in transition live in CSS; this only
        // flips the class. Desktop taps/clicks are ignored (the cursor splat
        // handles reveal there), and there's nothing to reveal unless the
        // Black & white setting is on.
        _onTap() {
          if (!this._mq.matches) return;
          if (!this.classList.contains('sqsh-prints-hero--bw')) return;
          this.classList.toggle('sqsh-prints-hero--revealed');
        }

        _onResize() {
          this.collapseGap();
          this.measure();
          if (this.watching) this.measureExit();
        }

        // The entry animation is pure CSS. This only decides when the letters leave.
        setupExit() {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.animate !== 'true' || reduced) return;

          this.exitPoint = parseFloat(this.dataset.exitPoint);
          if (isNaN(this.exitPoint)) this.exitPoint = 8;
          this.replay = this.dataset.replay === 'true';
          this.isOut = false;
          this.ticking = false;
          this.watching = true;

          // Captured on the document as well, so it still fires when the page
          // scrolls inside a wrapper element rather than the window itself.
          window.addEventListener('scroll', this._onScroll, { passive: true });
          document.addEventListener('scroll', this._onScroll, { passive: true, capture: true });
          this.measureExit();
        }

        stopWatching() {
          this.watching = false;
          window.removeEventListener('scroll', this._onScroll);
          document.removeEventListener('scroll', this._onScroll, true);
        }

        _onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(() => {
            this.ticking = false;
            this.measureExit();
          });
        }

        measureExit() {
          const rect = this.getBoundingClientRect();
          if (!rect.height) return;

          // Pixels the hero has travelled up past the top of the viewport, so the
          // exit fires on the first bit of scroll rather than deep into the image.
          const scrolled = -rect.top;
          const threshold = Math.max(this.exitPoint, 2);
          // A small band around the threshold so the letters don't flicker on it.
          const shouldExit = this.isOut ? scrolled > threshold - 2 : scrolled >= threshold;
          if (shouldExit === this.isOut) return;

          this.isOut = shouldExit;
          this.classList.toggle('sqsh-prints-hero--out', shouldExit);

          // Coming back up, rerun the reveal rather than just fading the lines in.
          if (!shouldExit) this.restartEntry();

          // Without replay, the exit is one-way and the listeners can retire.
          if (shouldExit && !this.replay) this.stopWatching();
        }

        restartEntry() {
          this.classList.remove('sqsh-prints-hero--motion');
          void this.offsetWidth; // forces the reflow that lets the animation start over
          this.classList.add('sqsh-prints-hero--motion');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-reveal"] && !Shopify.designMode) return;
  try {
    
class SqshRtReveal extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.targets = Array.from(this.querySelectorAll('[data-sqsh-reveal]'));
    if (!this.targets.length) return;

    this.targets.forEach((el) => this.split(el));

    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      this.targets.forEach((el) => el.style.setProperty('--sqsh-p', '1'));
      return;
    }

    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    window.addEventListener('load', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    if (this.onScroll) {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('load', this.onScroll);
    }
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const startLine = vh * 0.9;   // reveal begins when the element reaches here
    const endLine = vh * 0.35;    // fully revealed by here
    const span = startLine - endLine;

    this.targets.forEach((el) => {
      const top = el.getBoundingClientRect().top;
      let p = (startLine - top) / span;
      if (p < 0) p = 0;
      else if (p > 1) p = 1;
      el.style.setProperty('--sqsh-p', p.toFixed(4));
    });
  }

  split(el) {
    if (el.dataset.sqshSplit) return;

    const label = el.textContent.replace(/\s+/g, ' ').trim();
    const counter = { n: 0 };
    this.walk(el, counter);

    el.style.setProperty('--n', String(Math.max(counter.n, 1)));
    el.dataset.sqshSplit = 'true';
    if (label) el.setAttribute('aria-label', label);
  }

  walk(node, counter) {
    Array.from(node.childNodes).forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.textContent;
        if (!text) return;

        const frag = document.createDocumentFragment();
        for (const ch of text) {
          // Keep whitespace as real text nodes so lines still wrap normally.
          if (ch === ' ' || ch === '\n' || ch === '\t') {
            frag.appendChild(document.createTextNode(ch));
            continue;
          }
          const span = document.createElement('span');
          span.className = 'sqsh-char';
          span.setAttribute('aria-hidden', 'true');
          span.textContent = ch;
          span.style.setProperty('--i', String(counter.n++));
          frag.appendChild(span);
        }
        node.replaceChild(frag, child);
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        // Leave links untouched: don't split their text, so they keep their
        // normal link color and stay out of the reveal wave.
        if (child.tagName === 'A') return;
        this.walk(child, counter);
      }
    });
  }
}

if (!customElements.get('sqsh-rt-reveal')) {
  customElements.define('sqsh-rt-reveal', SqshRtReveal);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sqsh-originals-detail"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/

  // Pulls the section up by whatever gap the theme leaves above it — whether that
  // comes from the section wrapper, the page container, or an empty block above.
  if (!customElements.get('sqsh-original-detail')) {
    customElements.define(
      'sqsh-original-detail',
      class extends HTMLElement {
        connectedCallback() {
          this.mode = this.dataset.topBehavior || 'below';
          this._marked = [];
          this.lockHeader();
          this.markCurrentNavLink();
          this._onResize = this._onResize.bind(this);
          this.collapseGap();

          // The header is its own section. Whenever the editor re-renders it, the
          // dot and the colour lock are wiped with the old markup, so both are
          // re-applied here. Runs on load too, in case the header arrives late.
          this._onHeaderChange = () => {
            this.lockHeader();
            this.markCurrentNavLink();
          };
          document.addEventListener('shopify:section:load', this._onHeaderChange);
          window.addEventListener('load', this._onHeaderChange);

          // Re-measure once fonts, images and late-loading sections have settled.
          window.addEventListener('load', this._onResize);
          window.addEventListener('resize', this._onResize, { passive: true });
        }

        disconnectedCallback() {
          window.removeEventListener('load', this._onResize);
          window.removeEventListener('load', this._onHeaderChange);
          window.removeEventListener('resize', this._onResize);
          document.removeEventListener('shopify:section:load', this._onHeaderChange);
          const wrapper = this.closest('.shopify-section');
          if (wrapper) wrapper.style.marginTop = '';
          this.lockHeader('auto');
          this.clearCurrentNavLink();
        }

        /* A product URL never matches a menu link, so link.current is false for
           "Originals" and the header draws no dot. Mark it from here instead.

           Two ways to find the link, in order: the menu item's own text (set in
           the section settings, which works whatever the item points at), then
           the collections this product belongs to. Every match is marked, so the
           desktop nav and the mobile drawer both light up. */
        markCurrentNavLink() {
          this.clearCurrentNavLink();

          const label = (this.dataset.navLabel || '').trim().toLowerCase();
          const urls = (this.dataset.collectionUrls || '')
            .split(' ')
            .filter((u) => u.length > 1);
          if (!label && !urls.length) return;

          const groups = [
            ['.sqsh-header__nav-link', 'sqsh-header__nav-link--current'],
            ['.sqsh-drawer__link', 'is-current'],
          ];

          groups.forEach(([selector, className]) => {
            document.querySelectorAll(selector).forEach((link) => {
              if (!this.linkMatches(link, label, urls)) return;
              link.classList.add(className);
              link.setAttribute('aria-current', 'page');
              this._marked.push([link, className]);
            });
          });
        }

        linkMatches(link, label, urls) {
          if (label && (link.textContent || '').trim().toLowerCase() === label) {
            return true;
          }
          if (!urls.length) return false;

          const href = link.getAttribute('href');
          if (!href) return false;

          // Compare paths only — a query string, a hash or a trailing slash on
          // either side would otherwise break an exact match.
          const path = href.split('?')[0].split('#')[0].replace(/\/$/, '');
          return urls.some((url) => {
            const target = url.split('?')[0].replace(/\/$/, '');
            return path === target || path.indexOf(target + '/') === 0;
          });
        }

        clearCurrentNavLink() {
          (this._marked || []).forEach(([link, className]) => {
            link.classList.remove(className);
            link.removeAttribute('aria-current');
          });
          this._marked = [];
        }

        // The header decides its own colour from what is behind it. On this
        // template we override that, so the nav holds one colour throughout.
        lockHeader(force) {
          const header = document.querySelector('sqsh-site-header, .sqsh-site-header');
          if (!header) return;
          const choice = force || this.dataset.headerText || 'dark';
          header.classList.toggle('sqsh-original-detail-header-dark', choice === 'dark');
          header.classList.toggle('sqsh-original-detail-header-light', choice === 'light');
        }

        collapseGap() {
          if (this.mode === 'off') return;

          const wrapper = this.closest('.shopify-section') || this;
          wrapper.style.marginTop = '0px';

          const y = window.pageYOffset;
          const top = this.getBoundingClientRect().top + y;

          // "behind" pulls to the very top of the page, under a transparent header.
          // "below" stops at the bottom of the last thing that actually renders above
          // us — which may be a sibling of <main> rather than a sibling of this
          // section, so walk up until something with real height turns up.
          let target = 0;
          if (this.mode !== 'behind') {
            let node = wrapper;
            while (node && node !== document.body && target === 0) {
              let prev = node.previousElementSibling;
              while (prev) {
                const rect = prev.getBoundingClientRect();
                if (rect.height > 0) {
                  target = rect.bottom + y;
                  break;
                }
                prev = prev.previousElementSibling;
              }
              node = node.parentElement;
            }
          }

          const delta = top - target;
          if (delta > 0.5) {
            wrapper.style.marginTop = -delta + 'px';
          }
        }

        _onResize() {
          this.collapseGap();
        }
      }
    );
  }

  if (!customElements.get('sqsh-original-inquiry')) {
    customElements.define(
      'sqsh-original-inquiry',
      class SqshOriginalInquiry extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.status = this.querySelector('[data-sqsh-status]');
          this.button = this.querySelector('[data-sqsh-submit]');

          // Shopify bounces back to this page after a successful post; move focus
          // to the confirmation so screen readers land on it.
          const success = this.querySelector('[data-sqsh-success]');
          if (success) {
            success.focus({ preventScroll: false });
            return;
          }

          if (!this.form) return;
          this.fields = Array.from(this.querySelectorAll('[data-sqsh-field]'));

          this.fields.forEach((field) => {
            field.addEventListener('input', () => {
              // Only re-check once a field has already been flagged, so nobody is
              // told they're wrong halfway through typing their first letter.
              if (field.getAttribute('aria-invalid') === 'true') this.check(field);
              if (field.hasAttribute('data-sqsh-grow')) this.grow(field);
            });
            field.addEventListener('blur', () => {
              if (field.getAttribute('aria-invalid') === 'true') this.check(field);
            });
            if (field.hasAttribute('data-sqsh-grow')) this.grow(field);
          });

          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }

        // The form carries novalidate, so the browser's own bubbles stay out of
        // the way and every problem is shown at once, in the page's own type.
        handleSubmit(event) {
          const invalid = this.fields.filter((field) => !this.check(field));

          if (invalid.length) {
            event.preventDefault();
            this.announce(
              invalid.length === 1
                ? 'One field still needs filling in.'
                : invalid.length + ' fields still need filling in.'
            );
            invalid[0].focus();
            return;
          }

          this.announce('Sending your request.');
          if (this.button) this.button.setAttribute('aria-busy', 'true');
        }

        check(field) {
          const value = (field.value || '').trim();
          let message = '';

          if (!value) {
            message = field.dataset.error || 'Please fill in this field.';
          } else if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
            message = field.dataset.errorFormat || 'Please check your e-mail address.';
          }

          this.setError(field, message);
          return message === '';
        }

        setError(field, message) {
          const target = field.getAttribute('aria-describedby');
          const note = target ? document.getElementById(target) : null;

          if (message) {
            field.setAttribute('aria-invalid', 'true');
            if (note) {
              note.textContent = message;
              note.hidden = false;
            }
          } else {
            field.removeAttribute('aria-invalid');
            if (note) {
              note.textContent = '';
              note.hidden = true;
            }
          }
        }

        // Keeps the message box on one line until there's something to wrap.
        grow(field) {
          field.style.height = 'auto';
          field.style.height = field.scrollHeight + 'px';
        }

        announce(message) {
          if (this.status) this.status.textContent = message;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sqsh-prints-detail"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/

  // Pulls the section up by whatever gap the theme leaves above it — whether that
  // comes from the section wrapper, the page container, or an empty block above.
  if (!customElements.get('sqsh-print-detail')) {
    customElements.define(
      'sqsh-print-detail',
      class extends HTMLElement {
        connectedCallback() {
          this.mode = this.dataset.topBehavior || 'below';
          this.lockHeader();
          this.markCurrentNavLink();
          this._onResize = this._onResize.bind(this);
          this.collapseGap();
          // Re-measure once fonts, images and late-loading sections have settled.
          window.addEventListener('load', this._onResize);
          window.addEventListener('resize', this._onResize, { passive: true });
        }

        disconnectedCallback() {
          window.removeEventListener('load', this._onResize);
          window.removeEventListener('resize', this._onResize);
          const wrapper = this.closest('.shopify-section');
          if (wrapper) wrapper.style.marginTop = '';
          this.lockHeader('auto');
          this.clearCurrentNavLink();
        }

        // A product page URL never matches a collection link, so link.current is
        // false for "Prints" and the header draws no dot. Mark it from here, using
        // the collections this product actually belongs to.
        markCurrentNavLink() {
          const urls = (this.dataset.collectionUrls || '')
            .split(' ')
            .filter((u) => u.length > 1);
          if (!urls.length) return;

          this._marked = [];
          const groups = [
            ['.sqsh-header__nav-link', 'sqsh-header__nav-link--current'],
            ['.sqsh-drawer__link', 'is-current'],
          ];

          groups.forEach(([selector, className]) => {
            const links = document.querySelectorAll(selector);
            for (const link of links) {
              const href = link.getAttribute('href');
              if (!href) continue;
              if (urls.some((u) => href === u || href.indexOf(u + '/') === 0)) {
                link.classList.add(className);
                link.setAttribute('aria-current', 'page');
                this._marked.push([link, className]);
                break;
              }
            }
          });
        }

        clearCurrentNavLink() {
          (this._marked || []).forEach(([link, className]) => {
            link.classList.remove(className);
            link.removeAttribute('aria-current');
          });
          this._marked = [];
        }

        // The header decides its own colour from what is behind it. On this
        // template we override that, so the nav holds one colour throughout.
        lockHeader(force) {
          const header = document.querySelector('sqsh-site-header, .sqsh-site-header');
          if (!header) return;
          const choice = force || this.dataset.headerText || 'dark';
          header.classList.toggle('sqsh-print-detail-header-dark', choice === 'dark');
          header.classList.toggle('sqsh-print-detail-header-light', choice === 'light');
        }

        collapseGap() {
          if (this.mode === 'off') return;

          const wrapper = this.closest('.shopify-section') || this;
          wrapper.style.marginTop = '0px';

          const y = window.pageYOffset;
          const top = this.getBoundingClientRect().top + y;

          // "behind" pulls to the very top of the page, under a transparent header.
          // "below" stops at the bottom of the last thing that actually renders above
          // us — which may be a sibling of <main> rather than a sibling of this
          // section, so walk up until something with real height turns up.
          let target = 0;
          if (this.mode !== 'behind') {
            let node = wrapper;
            while (node && node !== document.body && target === 0) {
              let prev = node.previousElementSibling;
              while (prev) {
                const rect = prev.getBoundingClientRect();
                if (rect.height > 0) {
                  target = rect.bottom + y;
                  break;
                }
                prev = prev.previousElementSibling;
              }
              node = node.parentElement;
            }
          }

          const delta = top - target;
          if (delta > 0.5) {
            wrapper.style.marginTop = -delta + 'px';
          }
        }

        _onResize() {
          this.collapseGap();
        }
      }
    );
  }

  if (!customElements.get('sqsh-print-purchase')) {
    customElements.define(
      'sqsh-print-purchase',
      class SqshPrintPurchase extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.button = this.querySelector('[data-sqsh-buy]');
          this.status = this.querySelector('[data-sqsh-status]');
          if (!this.form) return;
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }

        get routeRoot() {
          const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
          return root || '/';
        }

        /* Hand off to Dawn's own cart drawer rather than reimplementing it.
           renderContents() injects the freshly rendered drawer markup and opens
           it, which is why the add request has to ask for those sections by
           their exact names.

           The drawer check happens INSIDE the handler, not at bind time: this
           section's script and cart-drawer.js are both deferred, so <cart-drawer>
           may not be upgraded to its real class yet when this element connects.
           Checking at click time is safe — every deferred script has finished
           long before anyone can physically click. */
        handleSubmit(event) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
            // No drawer on this theme: let the native submit through so the
            // customer can still buy. Lands on /cart.
            return;
          }

          event.preventDefault();
          this.setBusy(true);

          const body = new FormData(this.form);
          body.delete('return_to');
          // cart-drawer.js reads parsedState.sections['cart-drawer'] and
          // ['cart-icon-bubble'], so both must be requested by those exact names.
          body.append('sections', 'cart-drawer,cart-icon-bubble');
          body.append('sections_url', window.location.pathname);

          fetch(this.routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/javascript' },
            body: body,
          })
            .then((response) => response.json())
            .then((parsed) => {
              // Sold out, quantity rule, or any other add error — let the normal
              // submit surface Shopify's own message.
              if (parsed.status) {
                this.form.submit();
                return;
              }
              // renderContents() tries to clear "is-empty" but checks the wrong
              // element on this path, so the class survives and the CSS keeps
              // showing the empty state. We just added an item, so clear it here.
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(parsed);
              this.announce('Added to your cart.');
              this.refreshCartCount();
            })
            .catch(() => {
              this.form.submit();
            })
            .finally(() => {
              this.setBusy(false);
            });
        }

        /* The header renders its count as plain "Cart (n)" text rather than
           Dawn's #cart-icon-bubble, so renderContents has nothing to replace
           and the number would stay stale. Update it from the cart itself. */
        refreshCartCount() {
          fetch(this.routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((cart) => {
              document.querySelectorAll('.sqsh-header__cart').forEach((el) => {
                el.textContent = 'Cart (' + cart.item_count + ')';
                el.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
              });
            })
            .catch(() => {});
        }

        setBusy(state) {
          if (!this.button) return;
          this.button.setAttribute('aria-busy', String(state));
        }

        announce(message) {
          if (this.status) this.status.textContent = message;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
